// Canonical user-facing copy and message builders.
// Sentence case, no exclamation marks. See src/documentation/guides/CopyStyle.mdx.

// Generic fallback — use ONLY when no specific message is available.
export const GENERIC_ERROR = 'Something went wrong. Please try again.';

// Generic fallback with a support escalation — use when retrying alone may not resolve the issue.
export const GENERIC_ERROR_SUPPORT =
  'Something went wrong. Please try again. If the problem continues, contact support.';

// Permission denial — mirrors the backend's code-2 responses.
export const PERMISSION_DENIED = "You don't have permission to perform this action";

// The practitioner is already booked at the chosen time; shown with an "… anyway" override.
export const SCHEDULING_CONFLICT = "There's a scheduling conflict at this time";

// Validation
export const EMAIL_INVALID = 'Enter a valid email address';
// US-format only — for fields validated against the US phone regex. Fields
// validated with `validator.isMobilePhone` accept international numbers and must
// not use this wording.
export const US_PHONE_INVALID = 'Enter a valid US phone number';
export const FAX_INVALID = 'Invalid fax number';
export const DOB_SHORT_YEAR = 'Enter a 4-digit year';
export const DOB_INVALID = 'Enter a valid date of birth';
export const DOB_FUTURE = "Date of birth can't be in the future";
export const ZIP_INVALID = 'Enter a valid zip code (5 digits or 5+4)';
export const NPI_INVALID = 'NPI must be exactly 10 digits';
export const TAX_ID_INVALID = 'Tax ID must be exactly 9 digits';
export const TAX_ID_TYPE_INVALID = 'Tax ID type must be E (EIN) or S (SSN)';
export const CUSTOM_CHART_ID_INVALID = 'Use only letters, numbers and !@#$%^&*()-';
export const requiredMsg = (field) => `${field} is required`;

// Success builders — "{Thing} {past-tense verb}", no trailing period, no "!"
export const savedMsg = (thing = 'Changes') => `${thing} saved`;
export const createdMsg = (thing) => `${thing} created`;
export const updatedMsg = (thing) => `${thing} updated`;
export const deletedMsg = (thing) => `${thing} deleted`;

// Failure builder — "Couldn't {verb} {thing}"
export const failedMsg = (verb, thing) => `Couldn't ${verb} ${thing}`;
